/**
 * Generate metadata for PSP pages based on storage type
 * @param {string} storageType - The display name of the storage type (e.g., 'RV', 'Car', 'Climate Controlled')
 * @returns {object} Metadata object with title and description
 */
import { normalizeKeyword } from "../ContentMap";

const metadata = {
	rv: {
		title: "Find the Top RV Storage Units | Storage.com",
		description:
			"Find the top RV storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	car: {
		title: "Find the Top Car Storage Units | Storage.com",
		description:
			"Find the top car storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	"climate-controlled": {
		title: "Find the Top Climate Controlled Storage Units | Storage.com",
		description:
			"Find the top climate controlled storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	boat: {
		title: "Find the Top Boat Storage Units | Storage.com",
		description:
			"Find the top boat storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	portable: {
		title: "Find the Top Portable Storage Units | Storage.com",
		description:
			"Find the top portable storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	motorcycle: {
		title: "Find the Top Motorcycle Storage Units | Storage.com",
		description:
			"Find the top motorcycle storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	commercial: {
		title: "Find the Top Business Storage Units | Storage.com",
		description:
			"Find the top business storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	business: {
		title: "Find Affordable Business Self Storage | Storage.com",
		description:
			"Compare thousands of affordable business self storage options. Research facilities, view prices and photos, read reviews, and reserve today!"
	},
	wine: {
		title: "Find the Top Wine Storage Units | Storage.com",
		description:
			"Find the top wine storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	atv: {
		title: "Find the Top ATV Storage Units | Storage.com",
		description:
			"Find the top ATV storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	bicycle: {
		title: "Find the Top Bike Storage Units | Storage.com",
		description:
			"Find the top bicycle storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	"dirt-bike": {
		title: "Find the Top Dirt Bike Storage Units | Storage.com",
		description:
			"Find the top dirt bike storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	"golf-cart": {
		title: "Find the Top Golf Cart Storage Units | Storage.com",
		description:
			"Find the top golf cart storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	student: {
		title: "Find the Top College Storage Units | Storage.com",
		description:
			"Find the top college student storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	truck: {
		title: "Find the Top Storage Units with Free Truck Rentals | Storage.com",
		description:
			"Find the top storage units with free truck rentals. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	"jet-ski": {
		title: "Find the Top Jet Ski Storage Units | Storage.com",
		description:
			"Find the top jet ski storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	kayak: {
		title: "Find the Top Kayak Storage Units | Storage.com",
		description:
			"Find the top kayak storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	military: {
		title: "Find the Top Military Storage Units | Storage.com",
		description:
			"Find the top military storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	"drive-up": {
		title: "Find the Top Drive Up Storage Units | Storage.com",
		description:
			"Find the top drive up access storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	"24-hour": {
		title: "Find the Top 24-Hour Access Storage Units | Storage.com",
		description:
			"Find the top 24-hour access storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	vehicle: {
		title: "Find the Top Vehicle Storage Units | Storage.com",
		description:
			"Find the top vehicle storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	electricity: {
		title: "Find the Top Storage Units With Electricity | Storage.com",
		description:
			"Find the top storage units with electricity. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes."
	},
	"storage-101": {
		title: "A Beginner’s Guide to Renting a Storage Unit | Storage.com",
		description:
			"New to storage units? This beginner’s guide covers how self storage works, what to expect, and how to decide if a unit is right for your situation."
	}
};

export const getMetadata = (storageType) => {
	const key = normalizeKeyword(storageType);
	return (
		metadata[key] || {
			title: `Find the Top ${storageType} Storage Units | Storage.com`,
			description: `Find the top ${storageType} storage units. Compare prices, photos, and reviews, and explore secure facilities nationwide. Reserve online in minutes.`
		}
	);
};
